import React from "react";
import Container from "../../components/Container";
import Meta from "../../components/Meta";
import s from "./style.module.css";
import cn from "classnames";

const Header = ({
  title,
  intro,
  extraHeaderContent,
  icon,
  image,
  fullImage,
}) => (
  <div className={s.header}>
    <Container>
      {icon && <div className={s.icon}>{icon}</div>}

      <h1 className={s.headerText}>{title}</h1>

      {extraHeaderContent && <div>{extraHeaderContent}</div>}

      {intro && <p className={s.intro}>{intro}</p>}

      {image && (
        <img
          className={cn(s.image, { [s.fullImage]: fullImage })}
          src={`${image}`}
          alt=""
        />
      )}
    </Container>
  </div>
);

const Page = ({
  title,
  meta = {},
  children,
  footer,
  extraHeaderContent,
  beforeHeader,
  icon,
  intro,
  image,
  fullImage,
}) => {
  return (
    <Meta {...meta}>
      <div className={s.wrap}>
        {beforeHeader && beforeHeader}

        <Header
          title={title}
          extraHeaderContent={extraHeaderContent}
          icon={icon}
          intro={intro}
          image={image}
          fullImage={fullImage}
        />
        <Container large>
          <div className={s.content}>{children}</div>
        </Container>

        {footer && (
          <footer className={s.footer}>
            <Container>{footer}</Container>
          </footer>
        )}
      </div>
    </Meta>
  );
};

export default Page;
